var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelesiege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.09,42.11c-.09-.28-.4-.44-.68-.35l-1.56.51c-.28.09-.44.4-.35.68.33,1.02-.22,2.13-1.23,2.47l-41.05,14.14c-.28.1-.43.4-.33.68l.53,1.57c.05.14.14.25.27.31.07.04.16.06.24.06.06,0,.12,0,.18-.03l41.04-14.13c2.43-.81,3.75-3.46,2.94-5.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.04,22.78c.67.37,1.41.56,2.16.56.43,0,.86-.06,1.28-.19h0c2.39-.71,3.76-3.26,3.06-5.68-.34-1.18-1.11-2.15-2.18-2.74-1.06-.58-2.28-.71-3.43-.37-2.41.71-3.79,3.26-3.08,5.68.34,1.18,1.12,2.15,2.18,2.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.19,29.17l5.18,10.08c.96,1.82,2.84,2.63,4.78,2.06l8.86-2.69c.02,1.38.08,6.37.08,8.88,0,1.03.44,1.84,1.24,2.31.41.23.88.35,1.34.35s.94-.12,1.35-.36c.79-.46,1.22-1.27,1.22-2.28l-.05-12.68c0-1.04-.55-2.07-1.47-2.76-.75-.57-1.63-.78-2.34-.58l-8.6,2.47-4.54-8.71c-1.31-2.31-3.7-2.4-5.36-1.5-1.69.91-2.93,2.99-1.69,5.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.78,31.24c.1,0,.19-.01.29-.04l1.84-.51c.47-.13.79-.55.79-1.04V2.9c0-.6-.48-1.08-1.08-1.08h-1.84c-.6,0-1.08.48-1.08,1.08v27.26c0,.34.16.65.43.86.19.14.42.22.65.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.91,47.75c.91,0,1.78-.13,2.59-.38l5.28-1.56c.9-.27,1.52-.87,1.71-1.65.17-.72-.06-1.48-.59-1.98-.57-.54-1.4-.69-2.28-.42l-4.99,1.48-.33.07c-.43.1-.88.2-1.34.2-1.78,0-3.42-.99-4.26-2.59l-3.98-7.88c-.42-.84-1.12-1.35-1.91-1.39-.71-.03-1.42.31-1.82.92-.44.67-.45,1.54-.02,2.38l3.93,7.87c1.55,3.04,4.62,4.93,8.02,4.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelesiege);
export default __webpack_public_path__ + "static/media/telesiege.c65bb245d95c0bbedce5ef9c8a0d6256.svg";
export { ForwardRef as ReactComponent };